<template>
  <Header_cn/>
  <div class="lt-banner banner-style-1 bg-image">
    <div id="home-slider" class="carousel slide home-slider banner-content" data-ride="carousel">
      <div class="carousel-inner text-center">
        <div class="carousel-item active"
             style="background-image: url(/static/image/banner-bg1.png); background-size: cover; background-position: center;">
          <div style="background: rgba(1, 1, 1, 0.5); ">
            <div class="container">
              <div class="banner-text">
                <h1>寻找你的</h1>
                <h2>家居环境无限辉煌</h2>
                <p>开启对未来的憧憬，定制奢华的生活方式——高端门窗艺术，为您的每一刻增添色彩！</p>
              </div>
            </div>
          </div><!-- /.container -->
        </div><!-- /.carousel-item -->

        <div class="carousel-item"
             style="background-image: url(/static/image/banner-bg2.png); background-size: cover; background-position: center;">
          <div style="background: rgba(1, 1, 1, 0.5); ">
            <div class="container">
              <div class="banner-text">
                <h1>寻找你的</h1>
                <h2>家居环境无限辉煌</h2>
                <p>开启对未来的憧憬，定制奢华的生活方式——高端门窗艺术，为您的每一刻增添色彩！</p>
              </div>
            </div>
          </div><!-- /.container -->
        </div><!-- /.carousel-item -->

        <div class="carousel-item"
             style="background-image: url(/static/image/banner-bg3.png); background-size: cover; background-position: center;">
          <div style="background: rgba(1, 1, 1, 0.5); ">
            <div class="container">
              <div class="banner-text">
                <h1>寻找你的</h1>
                <h2>家居环境无限辉煌</h2>
                <p>开启对未来的憧憬，定制奢华的生活方式——高端门窗艺术，为您的每一刻增添色彩！</p>
              </div>
            </div>
          </div><!-- /.container -->
        </div><!-- /.carousel-item -->
      </div>
      <a class="carousel-control-prev" href="#home-slider" role="button" data-slide="prev">
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </a>
      <a class="carousel-control-next" href="#home-slider" role="button" data-slide="next">
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </a>
    </div><!-- /.home-slider -->
    <div class="mouse-inner-area text-center">
      <div class="container">
        <div class="mouse-inner">
          <div class="thumb">
            <img src="/static/picture/mouse-thumb.png" alt="Image" class="img-fluid">
            <a href="#about" class="mouse-icon">
              <span class="wheel"></span>
              <i class="fa fa-angle-down"></i>
            </a>
          </div>
        </div><!-- /.mouse-inner -->
      </div><!-- /.mouse-inner-area -->
    </div><!-- /.mouse-inner-area -->
  </div><!-- /.lt-banner -->

  <div class="lt-section" id="about">
    <div class="section-content about-content section-padding">
      <div class="about-thumb">
        <img src="/static/picture/about.png" alt="Image" class="img-fluid">
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="about-thumb-content">
              <div class="thumb">
                <img src="/static/picture/about2.jpg" alt="Image" class="img-fluid">
              </div>
              <div class="thumb thumb-2">
                <img src="/static/picture/about1.jpg" alt="Image" class="img-fluid">
              </div>
              <div class="lt-video">
                <a href="https://www.youtube.com/watch?v=rA81nm0NKYM"><span class="icon"><i class="fa fa-play"
                                                                                            aria-hidden="true"></i></span>Watch
                  Video</a>
              </div>
            </div><!-- /.about-thumb-content -->
          </div>
          <div class="col-lg-6 align-self-center">
            <div class="lt-about">
              <div class="section-title">
                <span>成立于2008年</span>
                <h1><span>冬夏</span> 门窗有限公司</h1>
                <p>我们拥有现代化标准厂房，现代化管理，引进德国高档门窗系统科研技术、生产设备和技术支持，
                  并由行业资深设计师提供家装门窗设计方案，10年专注铝合金门窗配套产品和销售一体化服务。</p>
              </div>
              <a href="/about" class="btn btn-primary radius">Read More</a>
            </div>
          </div>
        </div><!-- /.row -->
      </div><!-- /.container -->
    </div><!-- /.section-content -->
  </div><!-- /.lt-section -->

  <div class="lt-section">
    <div class="section-content section-padding bg-color">
      <div class="container">
        <div class="title-center">
          <div class="section-title">
            <h1>产品中心</h1>
            <div class="paragraph">
              <p>为您打造完美家园</p>
            </div>
          </div>
        </div><!-- /.title-center -->

        <div class="property-slider arrow-style-1">
          <div class="property style-1">
            <div class="thumb">
              <img src="/static/picture/Aluminum Window.jpg" alt="Image" class="img-fluid">
              <div class="overlay">
                <div class="property-status">
                  <a href="#">热销</a>
                </div>
                <div class="icons">
                  <ul class="global-list">
                    <li><a href="/products/?primary_category=Aluminum Window"><i class="fa fa-eye" aria-hidden="true"></i></a></li>
                    <li><a href="/static/picture/Aluminum Window.jpg" class="lt-popup"><i class="fa fa-search"
                                                                                    aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="property-info">
              <div class="info-top">
                <h2><a href="/products/?primary_category=Aluminum Window">铝合金窗</a></h2>
              </div>
            </div><!-- /.property-info -->
          </div><!-- /.property -->

          <div class="property style-1">
            <div class="thumb">
              <img src="/static/picture/Aluminum Door.jpg" alt="Image" class="img-fluid">
              <div class="overlay">
                <div class="property-status">
                  <a href="#">热销</a>
                </div>
                <div class="icons">
                  <ul class="global-list">
                    <li><a href="/products/?primary_category=Aluminum Door"><i class="fa fa-eye" aria-hidden="true"></i></a></li>
                    <li><a href="/static/picture/Aluminum Door.jpg" class="lt-popup"><i class="fa fa-search"
                                                                                    aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="property-info">
              <div class="info-top">
                <h2><a href="/products/?primary_category=Aluminum Door">铝合金门</a></h2>

              </div><!-- /.property-footer -->
            </div><!-- /.property-info -->
          </div><!-- /.property -->

          <div class="property style-1">
            <div class="thumb">
              <img src="/static/picture/Entrance door.jpg" alt="Image" class="img-fluid">
              <div class="overlay">
                <div class="property-status">
                  <a href="#">热销</a>
                </div>
                <div class="icons">
                  <ul class="global-list">
                    <li><a href="/products/?primary_category=Entrance door"><i class="fa fa-eye" aria-hidden="true"></i></a></li>
                    <li><a href="/static/picture/Entrance door.jpg" class="lt-popup"><i class="fa fa-search"
                                                                                    aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="property-info">
              <div class="info-top">
                <h2><a href="/products/?primary_category=Entrance door">入户门</a></h2>

              </div><!-- /.property-footer -->
            </div><!-- /.property-info -->
          </div><!-- /.property -->

          <div class="property style-1">
            <div class="thumb">
              <img src="/static/picture/Interiot door.jpg" alt="Image" class="img-fluid">
              <div class="overlay">
                <div class="property-status">
                  <a href="#">热销</a>
                </div>
                <div class="icons">
                  <ul class="global-list">
                    <li><a href="/products/?primary_category=Interiot door"><i class="fa fa-eye" aria-hidden="true"></i></a></li>
                    <li><a href="/static/picture/Interiot door.jpg" class="lt-popup"><i class="fa fa-search"
                                                                                    aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="property-info">
              <div class="info-top">
                <h2><a href="/products/?primary_category=Interiot door">物联网门</a></h2>
              </div><!-- /.property-footer -->
            </div><!-- /.property-info -->
          </div><!-- /.property -->

          <div class="property style-1">
            <div class="thumb">
              <img src="/static/picture/Sunroom.jpg" alt="Image" class="img-fluid">
              <div class="overlay">
                <div class="property-status">
                  <a href="#">热销</a>
                </div>
                <div class="icons">
                  <ul class="global-list">
                    <li><a href="/products/?primary_category=Sunroom"><i class="fa fa-eye" aria-hidden="true"></i></a></li>
                    <li><a href="/static/picture/Sunroom.jpg" class="lt-popup"><i class="fa fa-search"
                                                                                    aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="property-info">
              <div class="info-top">
                <h2><a href="/products/?primary_category=Sunroom">阳光房</a></h2>
              </div><!-- /.property-footer -->
            </div><!-- /.property-info -->
          </div><!-- /.property -->
        </div><!-- /.row -->
      </div><!-- /.container -->
    </div><!-- /.section-content -->
  </div><!-- /.lt-section -->

  <div class="lt-section">
    <div class="section-content section-padding text-center bg-image section-before"
         style="background-image: url(/static/image/featured-bg-1.jpg);">
      <div class="container">
        <div class="feature-content">
          <div class="row">
            <div class="col-md-4">
              <div class="feature style-one">
                <div class="feature-icon">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </div>
                <h2>专业</h2>
                <p>行业深度发展，技术领先，设计精良，质量保证。</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="feature style-one">
                <div class="feature-icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <h2>经验</h2>
                <p>十年积累，市场验证，成熟可靠，服务全面。</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="feature style-one">
                <div class="feature-icon">
                  <i class="fa fa-link" aria-hidden="true"></i>
                </div>
                <h2>效益</h2>
                <p>标准流程、快速响应、精准生产、高效服务。</p>
              </div>
            </div>
          </div>
        </div><!-- feature-content -->
      </div><!-- /.container -->
    </div><!-- /.section-content -->
  </div><!-- /.lt-section -->

  <div class="lt-section">
    <div class="section-content lt-get-a-quote section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 align-self-center">
            <div class="quote-info">
              <div class="thumb">
                <img src="/static/picture/quote-thumb.jpg" alt="Quote Image" class="img-fluid">
              </div>
              <div class="quote-text">
                <h2>使用下面的表格与我们联系。</h2>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="quote-form">
              <h1>立即获取免费在线报价！</h1>
              <span class="border"></span>
              <form action="#">
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Name*">
                  <input type="email" class="form-control" placeholder="Email*">
                  <input type="text" class="form-control" placeholder="Subject*">
                  <textarea name="message" class="form-control" placeholder="Message*" cols="30" rows="10"></textarea>
                  <input type="submit" value="Submit" class="btn btn-primary">
                </div>
              </form>
            </div>
          </div>
        </div>
      </div><!-- /.container -->
    </div><!-- /.section-content -->
  </div><!-- /.lt-section -->

  <div class="lt-section">
    <div class="section-content section-padding lt-testimonial bg-image"
         style="background-image: url(/static/image/testimonial-1.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="faq-accordion" id="faq-accordion">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                          aria-controls="collapseOne">冬夏的研发和设计优势是什么？
                  </button>
                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#faq-accordion">
                  <div class="card-body">
                    <p>引进德国技术，资深设计师团队，每年推出新产品，前沿设计，卓越品质。</p>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo"
                          aria-expanded="false" aria-controls="collapseTwo">生产质量是如何保证的？
                  </button>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#faq-accordion">
                  <div class="card-body">
                    <p>严格执行标准流程，多环节质量检验，现代化工厂和设备，确保准确性和稳定性。</p>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingThree">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree"
                          aria-expanded="false" aria-controls="collapseThree">产品种类丰富吗？
                  </button>
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#faq-accordion">
                  <div class="card-body">
                    <p>品种丰富，覆盖阳台、室内推拉门、窗户和折叠门等，满足多样化需求。</p>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingfour">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapsefour"
                          aria-expanded="false" aria-controls="collapsefour">服务理念是什么？
                  </button>
                </div>
                <div id="collapsefour" class="collapse" aria-labelledby="headingfour" data-parent="#faq-accordion">
                  <div class="card-body">
                    <p>信誉第一、客户至上、专业专注、全方位服务。</p>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive"
                          aria-expanded="false" aria-controls="collapseFive">销售网络怎么样？
                  </button>
                </div>
                <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#faq-accordion">
                  <div class="card-body">
                    <p>国内外600多家专卖店，覆盖范围广，出口多个国家，反应迅速。</p>
                  </div>
                </div>
              </div>
            </div><!-- /.faq-accordion -->
          </div>
          <div class="col-lg-6 align-self-center">
            <div class="testimonial-content testimonial-style-1 text-center">
              <div class="testimonial-nav-slider">
                <div class="testimonial-author">
                  <div class="author-image">
                    <img src="/static/picture/author-1.png" alt="Image" class="img-fluid">
                  </div>
                </div><!-- /testimonial-author -->

                <div class="testimonial-author">
                  <div class="author-image">
                    <img src="/static/picture/author-2.png" alt="Image" class="img-fluid">
                  </div>
                </div><!-- /testimonial-author -->

                <div class="testimonial-author">
                  <div class="author-image">
                    <img src="/static/picture/author-2.png" alt="Image" class="img-fluid">
                  </div>
                </div><!-- /testimonial-author -->

                <div class="testimonial-author">
                  <div class="author-image">
                    <img src="/static/picture/author-3.png" alt="Image" class="img-fluid">
                  </div>
                </div><!-- /testimonial-author -->
              </div><!-- testimonial-nav-slider -->

              <div class="testimonial-slider">
                <div class="testimonial">
                  <h2>David Smith</h2>
                  <span class="client-role">Software Engineer</span>
                  <p>Efficiently formulate viral data for error-free users. Distinctively provide access to fully tested
                    total linkage rather than process-centric infrastructures.</p>
                  <div class="quote-icon"><img src="/static/picture/quote1.png" alt="Image" class="img-fluid"></div>
                </div>

                <div class="testimonial">
                  <h2>David Smith</h2>
                  <span class="client-role">Software Engineer</span>
                  <p>Efficiently formulate viral data for error-free users. Distinctively provide access to fully tested
                    total linkage rather than process-centric infrastructures.</p>
                  <div class="quote-icon"><img src="/static/picture/quote1.png" alt="Image" class="img-fluid"></div>
                </div>

                <div class="testimonial">
                  <h2>David Smith</h2>
                  <span class="client-role">Software Engineer</span>
                  <p>Efficiently formulate viral data for error-free users. Distinctively provide access to fully tested
                    total linkage rather than process-centric infrastructures.</p>
                  <div class="quote-icon"><img src="/static/picture/quote1.png" alt="Image" class="img-fluid"></div>
                </div>
              </div><!-- testimonial-slider -->
            </div><!-- testimonial-content -->
          </div>
        </div><!-- /.row -->
      </div><!-- /.container -->
    </div><!-- /.section-content -->
  </div><!-- /.lt-section -->

  <div class="lt-section">
    <div class="section-content lt-blog section-padding bg-color">
      <div class="container">
        <div class="title-center">
          <div class="section-title">
            <h1>Latest Blog</h1>
            <div class="paragraph">
              <p>Learn about our news</p>
            </div>
          </div>
        </div><!-- /.title-center -->
        <div class="blog-slider arrow-style-1">
          <div class="tl-post">
            <div class="entry-header">
              <div class="entry-thumbnail">
                <a href="blog-details.html"><img src="/static/picture/42.jpg" alt="Image" class="img-fluid"></a>
              </div>
            </div>
            <div class="entry-content">
              <div class="entry-meta">
                <ul class="global-list">
                  <li><a href="#"><span class="mr-1 fa fa-clock-o"></span> 22 May 2023</a></li>
                </ul>
              </div>
              <h2 class="entry-title"><a href="blog-details.html">Dramatically leverage</a></h2>
              <p>Credibly incentivize diverse manufactured products through transparent.</p>
              <a class="read-more" href="blog-details.html">View More <span class="fa fa-arrow-right"></span></a>
            </div>
          </div><!-- /.tl-post  -->
          <div class="tl-post">
            <div class="entry-header">
              <div class="entry-thumbnail">
                <a href="blog-details.html"><img src="/static/picture/52.jpg" alt="Image" class="img-fluid"></a>
              </div>
            </div>
            <div class="entry-content">
              <div class="entry-meta">
                <ul class="global-list">
                  <li><a href="#"><span class="mr-1 fa fa-clock-o"></span> 22 May 2023</a></li>
                </ul>
              </div>
              <h2 class="entry-title"><a href="blog-details.html">Distinctively embrace</a></h2>
              <p>Credibly incentivize diverse manufactured products through transparent.</p>
              <a class="read-more" href="blog-details.html">View More <span class="fa fa-arrow-right"></span></a>
            </div>
          </div><!-- /.tl-post  -->
          <div class="tl-post">
            <div class="entry-header">
              <div class="entry-thumbnail">
                <a href="blog-details.html"><img src="/static/picture/63.jpg" alt="Image" class="img-fluid"></a>
              </div>
            </div>
            <div class="entry-content">
              <div class="entry-meta">
                <ul class="global-list">
                  <li><a href="#"><span class="mr-1 fa fa-clock-o"></span> 22 May 2023</a></li>
                </ul>
              </div>
              <h2 class="entry-title"><a href="blog-details.html">Proactively orchestrate</a></h2>
              <p>Credibly incentivize diverse manufactured products through transparent.</p>
              <a class="read-more" href="blog-details.html">View More <span class="fa fa-arrow-right"></span></a>
            </div>
          </div><!-- /.tl-post  -->
          <div class="tl-post">
            <div class="entry-header">
              <div class="entry-thumbnail">
                <a href="blog-details.html"><img src="/static/picture/17.jpg" alt="Image" class="img-fluid"></a>
              </div>
            </div>
            <div class="entry-content">
              <div class="entry-meta">
                <ul class="global-list">
                  <li><a href="#"><span class="mr-1 fa fa-clock-o"></span> 22 May 2023</a></li>
                </ul>
              </div>
              <h2 class="entry-title"><a href="blog-details.html">Collaboratively iterate</a></h2>
              <p>Credibly incentivize diverse manufactured products through transparent.</p>
              <a class="read-more" href="blog-details.html">View More <span class="fa fa-arrow-right"></span></a>
            </div>
          </div><!-- /.tl-post  -->
        </div><!-- /.blog-slider -->
      </div><!-- /.container -->
    </div><!-- /.section-content -->
  </div><!-- /.lt-section -->

  <Footer_cn/>
</template>

<script setup>

import Header_cn from "@/components/Header_cn.vue";
import Footer_cn from "@/components/Footer_cn.vue";
import {onMounted} from "vue";

onMounted(async () => {
  const scripts = [
    '/static/js/jquery-3.6.0.min.js',
    '/static/js/bootstrap.min.js',
    '/static/js/popper.min.js',
    '/static/js/magnific-popup.min.js',
    '/static/js/slick.min.js',
    '/static/js/counterup.min.js',
    '/static/js/waypoints.min.js',
    '/static/js/jquery-ui-min.js',
    '/static/js/jquery.nice-select.min.js',
    '/static/js/theia-sticky-sidebar.min.js',
    '/static/js/main1.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);
});
</script>
